import { colors } from '@material-ui/core';
import { blueGrey } from '@material-ui/core/colors';

const styles = (theme) => ({
  root: {
    flexGrow: 1,
  },
  fab: {
    position: 'fixed',
    bottom: theme.spacing(10),
    right: theme.spacing(6),
  },
  blue: {
    color: theme.palette.getContrastText(blueGrey[500]),
    backgroundColor: blueGrey[500],
    fontFamily: ['Roboto'],
  },
  marginTop: {
    marginTop: '24px',
  },
  checkboxPadding: {
    paddingTop: '6px',
  },
  space: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'stretch',
    },
  },
  actionMenuContainer: {
    width: '30%',
    display: 'flex',
    justifyContent: 'flex-end',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      justifyContent: 'flex-start',
    },
  },
  actionMenuButton: {
    minWidth: 140,
    [theme.breakpoints.down('sm')]: {
      minWidth: 120,
    },
  },
  percentaje: {
    marginRight: '10px',
    borderRadius: '100%',
    background: '#00897b',
    padding: '0 10px',
    color: 'white',
  },
  dialogTitle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingRight: theme.spacing(1),
  },
  titleContent: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
  },
  iconContainer: {
    width: 32,
    height: 32,
    backgroundColor: theme.palette.primary.main,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'white',
  },
  infoBox: {
    backgroundColor: '#f3f7f7',
    border: `1px solid  #00897b`,
    borderRadius: '#00897b',
    padding: theme.spacing(2),
    marginBottom: theme.spacing(3),
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  inputSection: {
    marginBottom: theme.spacing(3),
  },
  processSection: {
    marginBottom: theme.spacing(2),
  },
  chipContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
    marginTop: theme.spacing(2),
  },
  chip: {
    backgroundColor: theme.palette.grey[100],
    border: `1px solid ${theme.palette.grey[300]}`,
  },
});

export default styles;
